import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { FormOutlined, QrcodeOutlined, EyeOutlined } from '@ant-design/icons';
import { IS_EMBEDDED } from '../config';

const { Sider, Content, Header } = Layout;

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  const menuItems = [
    { key: '/', label: <Link to="/">Editor</Link>, icon: <FormOutlined /> },
    { key: '/qr', label: <Link to="/qr">QR Code</Link>, icon: <QrcodeOutlined /> },
    { key: '/preview', label: <Link to="/preview">Preview</Link>, icon: <EyeOutlined /> },
  ];

  if (IS_EMBEDDED) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider width={180} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: 13, fontWeight: 700 }}>
            Menu Builder
          </div>
          <Menu mode="inline" selectedKeys={[location.pathname]} items={menuItems} style={{ border: 'none' }} />
        </Sider>
        <Content style={{ background: '#fafafa' }}>{children}</Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', gap: 24, background: '#ff6b35', padding: '0 24px' }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 18 }}>Restaurant Menu</span>
      </Header>
      <Layout>
        <Sider width={180} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
          <Menu mode="inline" selectedKeys={[location.pathname]} items={menuItems} style={{ border: 'none', paddingTop: 8 }} />
        </Sider>
        <Content style={{ background: '#fafafa' }}>{children}</Content>
      </Layout>
    </Layout>
  );
}
